/** Texto legible para el usuario a partir de un error de la API.
 * FastAPI devuelve `detail` como texto, como lista (422) o como objeto; antes
 * el toast mostraba "[object Object]". */
export function apiError(error, fallback = 'Algo salió mal. Intenta de nuevo.') {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d) && d.length) {
    const f = d[0];
    return f?.msg ? `${(f.loc || []).slice(-1)[0] || 'Campo'}: ${f.msg}` : fallback;
  }
  if (d && typeof d === 'object') return d.message || d.msg || fallback;
  if (error?.message === 'Network Error') return 'Sin conexión. Revisa tu red e intenta de nuevo.';
  if (error?.code === 'ECONNABORTED') return 'La conexión tardó demasiado. Intenta de nuevo.';
  return fallback;
}
